import { CreateEntrepriseForm } from "../types/forms/create-entreprise-form";
import { UpdateEntrepriseForm } from "../types/forms/update-company-form";

export class EntrepriseService {
  constructor(private readonly apiUrl: string) {}

  async getEntrepriseById(idEntreprise: number) {
    try {
      const resultat = await fetch(
        `${this.apiUrl}/api/entreprises/${idEntreprise}`,
        {
          method: "GET",
          cache: "no-store",
          headers: {
            "Content-Type": "application/json",
          },
        },
      );

      if (!resultat.ok) {
        throw new Error(`Erreur HTTP: ${resultat.status}`);
      }

      return await resultat.json();
    } catch (error) {
      console.error("Erreur lors de la récupération de l'entreprise:", error);
      throw error;
    }
  }

  async getEntreprisesClientes() {
    try {
      const resultat = await fetch(`${this.apiUrl}/api/entreprises/client`, {
        method: "GET",
        cache: "no-store",
        headers: {},
      });

      if (!resultat.ok) {
        throw new Error(`Erreur HTTP: ${resultat.status}`);
      }

      return await resultat.json();
    } catch (error) {
      console.error(
        "Erreur lors de la récupération des entreprises clientes:",
        error,
      );
      throw error;
    }
  }

  async getEntreprisesPartenaires() {
    try {
      const resultat = await fetch(
        `${this.apiUrl}/api/entreprises/partenaire`,
        {
          method: "GET",
          cache: "no-store",
          headers: {},
        },
      );

      if (!resultat.ok) {
        throw new Error(`Erreur HTTP: ${resultat.status}`);
      }

      return await resultat.json();
    } catch (error) {
      console.error(
        "Erreur lors de la récupération des entreprises partenaires:",
        error,
      );
      throw error;
    }
  }

  async createEntreprise(entreprise: CreateEntrepriseForm) {
    try {
      const resultat = await fetch(`${this.apiUrl}/api/entreprises`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(entreprise),
      });

      if (!resultat.ok) {
        throw new Error(`Erreur HTTP: ${resultat.status}`);
      }
    } catch (error) {
      console.error("Erreur lors de la création de l'entreprise:", error);
      throw error;
    }
  }

  async createEntrepriseAdmin(entreprise: CreateEntrepriseForm) {
    try {
      const resultat = await fetch(`${this.apiUrl}/api/entreprises/admin`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(entreprise),
      });

      if (!resultat.ok) {
        throw new Error(await resultat.json().then((res) => res.message));
      }
    } catch (error) {
      console.error("Erreur lors de la création de l'entreprise:", error);
      throw error;
    }
  }

  async updateEntreprise(
    idEntreprise: number,
    entreprise: CreateEntrepriseForm,
  ) {
    try {
      const resultat = await fetch(
        `${this.apiUrl}/api/entreprises/${idEntreprise}`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(entreprise),
        },
      );

      if (!resultat.ok) {
        throw new Error(`Erreur HTTP: ${resultat.status}`);
      }
    } catch (error) {
      console.error("Erreur lors de la mise à jour de l'entreprise:", error);
      throw error;
    }
  }

  async createNewDemandApproval(idEntreprise: number) {
    try {
      const resultat = await fetch(
        `${this.apiUrl}/api/entreprises/${idEntreprise}/approbation`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
        },
      );

      if (!resultat.ok) {
        throw new Error(`Erreur HTTP: ${resultat.status}`);
      }
    } catch (error) {
      console.error("Erreur lors de la demande d'approbation:", error);
      throw error;
    }
  }

  async approbationEntreprise(
    idEntreprise: number,
    idApprobation: number,
    message: any,
  ) {
    try {
      const resultat = await fetch(
        `${this.apiUrl}/api/entreprises/${idEntreprise}/approbation/${idApprobation}`,
        {
          method: "PATCH",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(message),
        },
      );

      if (!resultat.ok) {
        throw new Error(`Erreur HTTP: ${resultat.status}`);
      }
    } catch (error) {
      console.error("Erreur lors de la mise à jour de l'entreprise:", error);
      throw error;
    }
  }

  async getCompanyWaitingApproval() {
    try {
      const resultat = await fetch(
        `${this.apiUrl}/api/entreprises/demande-approbation`,
        {
          method: "GET",
          cache: "no-store",
          headers: {},
        },
      );

      if (!resultat.ok) {
        throw new Error(`Erreur HTTP: ${resultat.status}`);
      }

      return await resultat.json();
    } catch (error) {
      console.error("Erreur lors de la mise à jour de l'entreprise:", error);
      throw error;
    }
  }

  async updateEntrepriseAdmin(
    idEntreprise: number,
    entreprise: UpdateEntrepriseForm,
  ) {
    try {
      const resultat = await fetch(
        `${this.apiUrl}/api/entreprises/${idEntreprise}/admin`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(entreprise),
        },
      );

      if (!resultat.ok) {
        throw new Error(`Erreur HTTP: ${resultat.status}`);
      }
    } catch (error) {
      console.error("Erreur lors de la mise à jour de l'entreprise:", error);
      throw error;
    }
  }

  async updateAdministrator(
    idEntreprise: number,
    data: { idAdministrateur: number },
  ) {
    try {
      const resultat = await fetch(
        `${this.apiUrl}/api/entreprises/${idEntreprise}/administrateur`,
        {
          method: "PATCH",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(data),
        },
      );

      if (!resultat.ok) {
        throw new Error(`Erreur HTTP: ${resultat.status}`);
      }
    } catch (error) {
      console.error("Erreur lors de la création de l'entreprise:", error);
      throw error;
    }
  }

  async getCollaborateurs(idEntreprise: number) {
    try {
      const resultat = await fetch(
        `${this.apiUrl}/api/entreprises/${idEntreprise}/collaborateurs`,
        {
          method: "GET",
          cache: "no-store",
          headers: {
            "Content-Type": "application/json",
          },
        },
      );

      if (!resultat.ok) {
        throw new Error(`Erreur HTTP: ${resultat.status}`);
      }

      return await resultat.json();
    } catch (error) {
      console.error(
        "Erreur lors de la récupération des collaborateurs:",
        error,
      );
      throw error;
    }
  }

  async deleteCollaborateur(idEntreprise: number, idCollaborateur: number) {
    try {
      const resultat = await fetch(
        `${this.apiUrl}/api/entreprises/${idEntreprise}/collaborateurs/${idCollaborateur}`,
        {
          method: "delete",
          headers: {
            "Content-Type": "application/json",
          },
        },
      );

      if (!resultat.ok) {
        throw new Error(`Erreur HTTP: ${resultat.status}`);
      }
    } catch (error) {
      console.error("Erreur lors de la suppression du collaborateur:", error);
      throw error;
    }
  }

  async getDriversFromCompany(idEntreprise: number) {
    try {
      const resultat = await fetch(
        `${this.apiUrl}/api/entreprises/${idEntreprise}/chauffeur`,
        {
          method: "GET",
          cache: "no-store",
          headers: {
            "Content-Type": "application/json",
          },
        },
      );

      if (!resultat.ok) {
        throw new Error(`Erreur HTTP: ${resultat.status}`);
      }

      return await resultat.json();
    } catch (error) {
      console.error("Erreur lors de la récupération des chauffeurs:", error);
      throw error;
    }
  }
}
